/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

!function () {
    "use strict";

    angular.module('webReader').service('DocumentModel', constructor);

    function constructor(NetworkService, Styles, $timeout, $document, $cookieStore, DOCUMENT_INFORMATION_PROCESSING_TIMEOUT, ModalService) {
        var self = this;
        var docPath = '';
        var onModelUpdateCallbacks = [];
        var onChapterLoadedCallbacks = {};
        var onChapterStatusChangeCallbacks = {};
        var onChaptersStatusChangeCallbacks = [];
        var onModelCreatedCallbacks = [];
        var totalContentLength = 0;
        var loadedContentLength = 0;
        var wrapperHeight = 0;
        var chaptersRendered = {};
        var modelIsUpdated;
        var bookFormat = '';


        angular.extend(self, {
            subscribe: {
                onModelCreated: function (callbackFunction) {
                    onModelCreatedCallbacks.push(callbackFunction);
                },
                onModelUpdate: function (callbackFunction) {
                    onModelUpdateCallbacks.push(callbackFunction);

                    if (self.checkIf.isModelUpdated()) {
                        self.executeSubscriptions.call(this, [callbackFunction], []);
                    }
                },
                onChapterLoaded: function (chapterIndex, callBackFunction) {
                    if (_.isUndefined(onChapterLoadedCallbacks[chapterIndex])) {
                        onChapterLoadedCallbacks[chapterIndex] = [];
                    }

                    onChapterLoadedCallbacks[chapterIndex].push(callBackFunction);
                    return onChapterLoadedCallbacks[chapterIndex].length - 1;
                },
                onChapterStatusChange: function (chapterIndex, callBackFunction) {
                    if (_.isUndefined(onChapterStatusChangeCallbacks[chapterIndex])) {
                        onChapterStatusChangeCallbacks[chapterIndex] = [];
                    }

                    onChapterStatusChangeCallbacks[chapterIndex].push(callBackFunction);
                    return onChapterStatusChangeCallbacks[chapterIndex].length - 1;
                },
                onChaptersStatusChange: function (callbackFunction) {
                    onChaptersStatusChangeCallbacks.push(callbackFunction);
                },
                clear: function () {
                    onModelUpdateCallbacks = [];
                }
            },
            unsubscribe: {
                onChapterLoaded: function (chapterIndex, callbackId) {
                    if (!_.isNull(onChapterLoadedCallbacks[chapterIndex]) &&
                        !_.isNull(onChapterLoadedCallbacks[chapterIndex][callbackId])) {
                        onChapterLoadedCallbacks[chapterIndex][callbackId] = null;
                    }
                },
            },

            executeSubscriptions: function (callbacks, args) {
                var self = this;
                return _.every(callbacks, function (fn) {
                    if (!_.isNull(fn)) {
                        return fn.apply(self, [args]) !== false;
                    }
                })
            },

            checkIf: {
                isChapterLoaded: function (chapterId) {
                    return !!self.chaptersContent[chapterId];
                },
                isChapterRendered: function (chapterId) {
                    return !!chaptersRendered[chapterId];
                },
                isModelUpdated: function () {
                    return !!modelIsUpdated;
                }
            },

            create: function (documentPath) {
                NetworkService.updateHeader();
                docPath = documentPath;
                self.executeSubscriptions.call(this, onModelCreatedCallbacks, []);
            },
            invoke: function () {
                var cookieStore = $cookieStore;

                NetworkService.getDocumentInfo(docPath).then(function (data) {
                    // console.log(data)
                    if (data.status && data.status == 'processing') {
                        $timeout(self.invoke, DOCUMENT_INFORMATION_PROCESSING_TIMEOUT);
                    } else if (data.status && data.status === 'failed') {
                        // console.log(data.status);
                        ModalService.showModal({
                            template: '<div class="modal fade">' +
                            '<div class="modal-dialog">' +
                            '<div class="modal-content">' +
                            '<div class="modal-header">' +
                            ' <button type="button" class="close" ng-click="close(true)" data-dismiss="modal" aria-hidden="true">&times;</button>' +
                            '<h4 class="modal-title" rd-translate-alias="CantReadBook">Read book </h4>' +
                            '</div>' +
                            '<div class="modal-body">' +
                            '<p  rd-translate-alias="CantReadBookRedirect">Cannot read</p>' +
                            "</div>" +
                            '<div class="modal-footer">' +
                            '<button type="button" ng-click="close(true)" class="btn btn-default" data-dismiss="modal" rd-translate-alias="OK">Ok</button>' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>',
                            controller: ['$scope', 'close', function ($scope, close) {
                                $scope.close = function (result) {
                                    close(result, 500); // close, but give 500ms for bootstrap to animate
                                    window.location.href = '/browser/#access_token=' + cookieStore.get('accessToken') + '&refresh_token=' + cookieStore.get('refreshToken');
                                };

                            }],
                            controllerAs: '$ctrl'
                        }).then(function (modal) {
                            modal.element.modal();
                        });

                    } else {
                        self.update(data);
                    }
                });
                return NetworkService.getDocumentMeta(docPath);
            },
            documentInfoProcessors: {
                'epub': function () {
                    self.documentInformation.files && !!self.documentInformation.files.length &&
                        _.each(self.documentInformation.files, function (el, i, collection) {
                            totalContentLength += el.length;
                        });
                },
                'pdf': function () {
                    if (!!self.documentInformation.pages) {
                        totalContentLength = self.documentInformation.pages.count;
                        self.documentInformation.files = [];

                        for (var i = 0; i < totalContentLength; i++) {
                            self.documentInformation.files.push({
                                url: 'pbr:/page?page=' + i
                            });
                        }
                    };
                }
            },
            update: function (data) {
                console.warn('DATA: ' ,data);
                bookFormat = data.format;
                self.documentInformation = data;
                $document.title = data.authors.join(', ') + ' � �' + data.title + '�';

                //calculate total content length
                self.documentInfoProcessors[bookFormat]();

                //self.loadChapters();
                self.executeSubscriptions.call(this, onModelUpdateCallbacks, []);
                modelIsUpdated = true;
            },
            getDocumentFormat: function () {
                return bookFormat;
            },
            loadChapters: function () {
                self.documentInformation.files && !!self.documentInformation.files.length &&
                    _.each(self.documentInformation.files, function (el, i, collection) {
                        self.loadChapter(i);
                    });
            },
            loadChapterByFormat: {
                'epub': function (chapterIndex) {
                    var el = self.documentInformation.files[chapterIndex];

                    self.updateChapterStatus(chapterIndex, 'LOADING');
                    el.index = chapterIndex;
                    el.style = Styles.getNewStyleSheetName();
                    Styles.setStyleBaseUrl(chapterIndex, self.documentInformation.baseUrl + self.getChapterBaseUrl(chapterIndex));

                    NetworkService.getChapterContent(self.documentInformation.baseUrl + el.url)
                        .then(self.updateChapterContent(chapterIndex));
                },
                'pdf': function (chapterIndex) {
                    //pdf does not require styles
                    var el = self.documentInformation.files[chapterIndex];

                    self.updateChapterStatus(chapterIndex, 'LOADING');
                    el.index = chapterIndex;
                    el.style = Styles.getNewStyleSheetName();
                    Styles.setStyleBaseUrl(chapterIndex, self.documentInformation.baseUrl + self.getChapterBaseUrl(chapterIndex));
                    //in case of pdf - just passing of image url
                    NetworkService.getChapterPDFContent(self.documentInformation.baseUrl + self.getChapterBaseUrl(chapterIndex))
                        .then(self.updateChapterContent(chapterIndex));
                }
            },
            loadChapter: function (chapterIndex) {
                self.loadChapterByFormat[self.getDocumentFormat()](chapterIndex);
            },
            updateChapterContent: function (chapterId) {
                var _chapterId = chapterId;

                return function (data) {
                    self.chaptersContent[chapterId] = data;
                    self.updateChapterStatus(_chapterId, 'LOADED');
                    onChapterLoadedCallbacks[chapterId] && self.executeSubscriptions.call(this, onChapterLoadedCallbacks[chapterId], []);
                }
            },
            updateChapterStatus: function (chapterId, newStatus) {
                self.documentInformation.files[chapterId].status = newStatus;
                onChapterStatusChangeCallbacks[chapterId] && self.executeSubscriptions.call(this, onChapterStatusChangeCallbacks[chapterId], [{ chapterId: chapterId, newStatus: newStatus }]);
                onChaptersStatusChangeCallbacks.length && self.executeSubscriptions.call(this, onChaptersStatusChangeCallbacks, [{ chapterId: chapterId, newStatus: newStatus }]);
            },
            updateChaptersOffsets: function () {
                // debugger
                var chaptersDOMCollection = angular.element('content-viewport > content-wrapper > div');
                var lastAssignedOffset = 0;
                var lastDOMIndex = 0;

                _.each(self.documentInformation.files, function (el, i) {
                    if (self.getChapterStatus(i) === 'LOADED') {
                        el.offsetPx = -angular.element(chaptersDOMCollection[lastDOMIndex]).position().top;
                        //lastAssignedOffset -=
                        lastDOMIndex += 1;
                    }
                });
            },
            updateWrapperHeight: function (newHeight) {
                wrapperHeight = newHeight;
            },
            getChapterIdByUrl: function (chapterUrl) {
                var chapterId;

                for (chapterId = 0; chapterId < self.documentInformation.files.length &&
                    self.documentInformation.files[chapterId].url !== chapterUrl; chapterId++) { };

                return chapterId === self.documentInformation.files.length ? -1 : chapterId;
            },
            getChapterUrlById: function (chapterId) {
                return self.documentInformation.files[chapterId].url;
            },
            getChapterOffset: function (chapterId) {
                return self.documentInformation.files[chapterId].offsetPx;
            },
            getChapterStatus: function (chapterId) {
                return self.documentInformation.files[chapterId].status;
            },
            getDocumentBaseInformation: function () {
                return self.documentInformation;
            },
            getDocumentInformation: function () {
                return self.documentInformation.files;
            },
            getChaptersCount: function () {
                return self.documentInformation.files.length;
            },
            getLoadedContentLength: function () {
                return loadedContentLength;
            },
            getTotalContentLength: function () {
                return totalContentLength;
            },
            getChapterLength: function (chapterId) {
                if (chapterId < 0) {
                    chapterId = self.documentInformation.files.length - 1;
                }
                    return self.documentInformation.files[chapterId].length;

            },
            getChapterContent: function (chapterId) {
                return !!self.chaptersContent[chapterId] ? self.chaptersContent[chapterId] : {};
            },
            getChapterBaseUrlByFormat: {
                'epub': function (chapterId) {
                    if (!!(self.documentInformation.files[chapterId].url.lastIndexOf('/') + 1)) {
                        return self.documentInformation.files[chapterId].url.substring(0, self.documentInformation.files[chapterId].url.lastIndexOf('/') + 1);
                    } else {
                        return '';
                    }
                },
                'pdf': function (chapterId) {
                    if (!this.pdfSize) {
                        var screenWidth = screen.width;

                        if (screenWidth <= 1200) {
                            this.pdfSize = 'small';
                        } else if (screenWidth <= 1800) {
                            this.pdfSize = 'medium';
                        } else {
                            this.pdfSize = 'large';
                        }

                        this.contentBlockWidth = screenWidth - 300;

                        angular.element('reader-chaptercollection content-block').addClass('format-pdf').css('width', this.contentBlockWidth);
                    }

                    return this.pdfSize + '/page-' + /[^d+](\d+)/ig.exec(self.documentInformation.files[chapterId].url)[1] + '.png';
                },
                pdfSize: null,
                contentBlockWidth: null
            },
            getChapterBaseUrl: function (chapterId) {
                return self.getChapterBaseUrlByFormat[self.getDocumentFormat()](chapterId);
            },
            getContentItems: function () {
                //chapters arr
                return (self.documentInformation && self.documentInformation.toc) || [];
            },
            getPagesCountBeforeLoaded: function () {
                //self.getLoadedContentLength() / self.getTotalContentLength() * wrapperHeight;

                return wrapperHeight / (self.getLoadedContentLength() / self.getTotalContentLength());
            },

            getDocumentPath: function () {
                return docPath;
            },
            getPreviousChaptersLengthByFormat: {
                'epub': function () {
                    var length = 0;

                    for (var i = 0; i < self.documentInformation.files.length && !self.documentInformation.files[i].status; i++) {
                        length += self.documentInformation.files[i].length;
                    }

                    return length;
                },
                'pdf': function () {
                    var length = 0;

                    for (var i = 0; i < self.documentInformation.files.length && !self.documentInformation.files[i].status; i++) {
                        length += 1;
                    }

                    return length;
                }
            },
            getPreviousChaptersLength: function () {
                return self.getPreviousChaptersLengthByFormat[self.getDocumentFormat()]();
            },
            getLoadedChapters: function () {
                return _.filter(self.documentInformation.files, function (el) {
                    return el.status && el.status === 'LOADED';
                });
            },
            updateChapterLengthByFormat: {
                'epub': function (chapterId) {
                    // console.warn('EPUB: loadedContentLength before', loadedContentLength);
                    // console.warn('EPUB: chapterId', chapterId);
                    loadedContentLength += self.documentInformation.files[chapterId].length
                },
                'pdf': function (chapterId) {
                    loadedContentLength += 1;
                }
            },
            setChapterRendered: function (chapterId) {
                chaptersRendered[chapterId] = true;
                self.updateChapterLengthByFormat[bookFormat](chapterId);
            },
            getChapterByIndex: function (index) {
                var loadedChapters = self.getLoadedChapters();
                var result = 0;

                for (; result < loadedChapters.length && loadedChapters[result].index !== index; result++) { }
                return (loadedChapters[result].index === index) ? loadedChapters[result] : null;
            },
            getTranslation: function (sourceString) {
                return NetworkService.getTranslation(sourceString);
            },

            documentInformation: {},
            chaptersContent: {}
        });
    }
    constructor.$inject = ["NetworkService", "Styles", "$timeout", "$document", "$cookieStore", "DOCUMENT_INFORMATION_PROCESSING_TIMEOUT", "ModalService"];
}();